export const isKeyboardEvent = (e: React.MouseEvent | React.KeyboardEvent): e is React.KeyboardEvent => {
  return e.nativeEvent instanceof KeyboardEvent
}
